import React from 'react';
import { CakeIcon, CalculatorIcon, ClipboardListIcon, FrameIcon, HammerIcon, PartyPopperIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PRODUCT_NAME, tomos } from '../data/content';
const ICONS = {
  clipboard: ClipboardListIcon,
  party: PartyPopperIcon,
  frame: FrameIcon,
  cake: CakeIcon,
  hammer: HammerIcon,
  calculator: CalculatorIcon
};

/* Colores de cada tomo, siguiendo la paleta del pack */
const TOMO_COLORS = ['bg-party-rose text-white', 'bg-party-pastel text-party-ink', 'bg-party-gold text-party-ink', 'bg-party-wine text-white', 'bg-party-brown text-white', 'bg-party-ink text-party-gold'];
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="bg-party-ink" data-id="element-161" data-mp="5xnkgu84l6rv">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-162" data-mp="kt3dqx0vsyn7">
        <p className="font-sans text-[0.62rem] font-bold uppercase tracking-[0.14em] text-party-gold" data-id="element-163" data-mp="fujskyu43qvw">
          La solución que estabas buscando — un sistema 6 en 1
        </p>
        <h2 id="solucion" className="mt-1.5 font-display text-lg font-extrabold leading-tight text-white sm:text-2xl" data-id="element-164" data-mp="3b9firi7div5p">
          6 tomos en un solo sistema, creados para aprender desde cero.
        </h2>
        <p className="mt-1 font-sans text-[0.75rem] font-extrabold uppercase leading-tight text-party-pastel sm:text-sm" data-id="element-165" data-mp="3kb6kyd2pgjut">
          {PRODUCT_NAME}
        </p>
        <p className="mx-auto mt-1.5 max-w-xl text-[0.78rem] leading-snug text-white/80" data-id="element-166" data-mp="3u8b8ag8aeld7">
          No es simplemente otro ebook de decoración. Es una ruta de aprendizaje
          que organiza los conocimientos fundamentales para que comprendas qué
          aprender primero, qué viene después y cómo conectar cada parte de una
          decoración completa.
        </p>

        <ol className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-167" data-mp="bsh7od89ipqw">
          {tomos.map((tomo, i) => {
          const Icon = ICONS[tomo.icon];
          return <Reveal key={tomo.title} as="li" delay={i * 0.03} className="flex h-full overflow-hidden rounded-lg bg-white text-left text-party-ink" data-id="element-168" data-mp="2cxunsd17plx8" data-mpi={i}>
                <span className={`flex w-12 flex-shrink-0 flex-col items-center justify-center gap-1 ${TOMO_COLORS[i]}`} data-id="element-169" data-mp="2mopebtlhr7oh">
                  <span className="font-sans text-[0.5rem] font-bold uppercase tracking-wider" data-id="element-170" data-mp="2vmj5yr8b9d5b">
                    Tomo
                  </span>
                  <span className="font-display text-2xl font-black leading-none" data-id="element-171" data-mp="2rns7ogs3zpgm">
                    {i + 1}
                  </span>
                  <Icon size={13} aria-hidden="true" data-id="element-172" data-mp="30lvvjjqkgybl" />
                </span>
                <div className="p-2.5" data-id="element-173" data-mp="1b7fvn9a6sjo8">
                  <h3 className="sr-only" data-id="element-174" data-mp="1b8im5g3lkk3m">Tomo {i + 1}</h3>
                  <p className="font-sans text-[0.78rem] font-extrabold uppercase leading-tight" data-id="element-175" data-mp="168cqlou7idg9">
                    {tomo.title}
                  </p>
                  <p className="mt-0.5 text-[0.74rem] leading-snug text-party-ink/75" data-id="element-176" data-mp="3hx11ukpfah3a">
                    {tomo.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ol>

        <CtaButton href={OFFER_ANCHOR} className="mt-3" data-id="element-177" data-mp="385mzm563736g">
          🚀 Sí, quiero comenzar ahora
        </CtaButton>
      </div>
    </section>;
}